import { css } from "@emotion/react";

import { Badge, BadgeColors } from "@dotnet/telematics-design-system";

import {
    TOOLTIP_PLACEMENT,
    TooltipGeneral
} from "components/DesignComponents/Tooltips";
import { useFormattedNumber } from "shared/hooks/useFormattedNumber";

import { CountBadgeWithTooltipProps } from "./types";

const CountBadgeWithTooltip = ({
    count,
    tooltip,
    tooltipPlacement
}: CountBadgeWithTooltipProps) => {
    const { renderFormattedNumber } = useFormattedNumber();

    return count > 0 ? (
        <TooltipGeneral
            title={tooltip}
            placement={tooltipPlacement ?? TOOLTIP_PLACEMENT.Right}
            removeArrow
        >
            <span css={css({ display: "inline-flex", cursor: "default" })}>
                <Badge color={BadgeColors.light}>
                    {renderFormattedNumber(count)}
                </Badge>
            </span>
        </TooltipGeneral>
    ) : (
        "-"
    );
};

export default CountBadgeWithTooltip;
